import { IUploadBrandDetailsDTO } from '@/models/brands.model';
import { BrandsFormFields, TUpdateBrandFormValues } from '../helpers/types';
import { IBlogSeo } from '@/models/blogPost.model';

class UpdateBrandsDTO implements IUploadBrandDetailsDTO {
  channelId: number;

  id: string;

  logo?: File;

  banner?: File;

  title?: string;

  description?: string;

  bannerTitle?: string;

  imageTitle?: string;

  seo?: IBlogSeo;

  constructor(values: TUpdateBrandFormValues & { id: string; channelId: number }) {
    this.channelId = values.channelId;
    this.id = values.id;
    if (typeof values[BrandsFormFields.LOGO] !== 'string') {
      this.logo = values[BrandsFormFields.LOGO];
    }

    if (typeof values[BrandsFormFields.BANNER] !== 'string') {
      this.banner = values[BrandsFormFields.BANNER];
    }

    this.title = values[BrandsFormFields.TITLE];
    this.description = values[BrandsFormFields.DESCRIPTION];
    this.imageTitle = values[BrandsFormFields.IMAGE_TITLE];
    this.bannerTitle = values[BrandsFormFields.BANNER_TITLE];
    this.seo = values[BrandsFormFields.SEO];
  }
}

export default UpdateBrandsDTO;
